import { Button } from '../Button';
import { Text } from '../Text';

export type LayerCatalogErrorProps = {
  onRetry: () => void;
  /** Distinguishes user vs org Layer Library test ids (e.g. 'layer-library-catalog' | 'org-layer-library-catalog'). */
  testIdPrefix: string;
  message?: React.ReactNode;
};

/**
 * Catalog load-error + retry block, shown in place of the layer table when the
 * catalog query fails. Shared between the per-user and org Layer Library pages.
 */
function LayerCatalogError({
  onRetry,
  testIdPrefix,
  message = 'Couldn’t load the layer catalog.',
}: LayerCatalogErrorProps) {
  return (
    <div
      data-testid={`${testIdPrefix}-error`}
      className="flex flex-col items-start gap-2 rounded border border-grey-20 bg-grey-5 p-8"
    >
      <Text className="text-sm text-grey-90">{message}</Text>
      <Button variant="secondary" size="small" onClick={onRetry} data-testid={`${testIdPrefix}-retry`}>
        Retry
      </Button>
    </div>
  );
}

export { LayerCatalogError };
